
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>G H Raisoni Chess Tournament 2025</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-7">
                <p>G H Raisoni Memorial Nandurbar selection chess tournament was held in the gymkhana hall of G.T. Patil College in Association with Raisoni Foundation- Sports and Culture and Kalpana Prakash Welfare Foundation A total of 82 players participated in the competition. Out of these, 10 players were selected from the open category. Cash prize worth Rs. 30000 and trophies were distributed to the winners.</p>
                <p>The competition was inaugurated by Dr. Shirishkumar Shinde and Vice-Principal Suresh Patil. From the open category, the following 10 players were selected for the state level:Rand Bhambre, Sakshi Chavan, Dakshil Devare, Tirth Sharma, Bhandari, Arnavsing Patil, Praharsh Patil, Aarohi Sali, Devang Pawar.
                </p>
                <p>In the junior category, Durvesh Thakur, Adesh Bedse, and Avani Mahale were selected. In the 55+ age category, Nandkishore Pardeshi was selected. From the women’s category, Nehal Jain and Vaishali Mankar were selected.</p>

            </div>
            <div class="col-md-5">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-1.avif"
                        alt="GHRSCF" />

                </div>
            </div>
            <p>Officials for the event included Sandeep Salunke, Prof. D. A. Patil, Ashik Bora, and Rahul Khedkar. The event was hosted by Prof. Subhash Moravkar. Kedar Patil, Aamir Khan, and others worked hard to ensure the event’s success.</p>
            <p>In the open category, Nishant Shinde secured the first position. In the under-13 age group, Om Ramraje took first place.</p>
            <p>Other selected players from the open category include: Siddharth Pardeshi, Rishikesh Sonar, Sagar Mahajan, Bhavesh Marathe, Nitin Ghodke, Shubham Bawiskar, Jaydeep Randive, Nikita Bagul, and Vishwajeet Shinde.</p>
            <p>In the under-13 group, Devansh Gele was also selected.</p>
        </div>

        <div class="col-lg-6">
            <div class="gall-ery">
                <div class="row">
                    <div class="col-md-8">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a> -->
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-1.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-1.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-2.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-2.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-3.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-3.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-4.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-4.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>

    </div>

</section>
